export const POSITION_Y_STICKYBAR_DISPLAY = -100
